module.exports = __webpack_public_path__ + "media/journey1-B.be86124f.mp4";